import { BASE_API_URL_CAP_DIEN } from "@utils/constants";

export const APIMucTroNgai = {
  LIST_TRO_NGAI: `${BASE_API_URL_CAP_DIEN}/tro-ngai/list`,
  SYNC_TRO_NGAI: `${BASE_API_URL_CAP_DIEN}/tro-ngai/sync`,
};
